import { Grid, withStyles } from "@material-ui/core";
import React from "react";
import styles from "../styles";
import { formatMonthDateYearWithoutUTC } from "../../../../../../../dataGrid/gridUtilities"

const index = ({ classes, data }) => {
  return (
    <div>
      <div className={classes.sectionTitle}>Pickup Status</div>
      <Grid container className={classes.infoContainer}>
        <Grid item xs={3} className={classes.rightPanelInfoSection}>
          <div className={classes.infoTitle}>Status:</div>
          <div className={`${classes.infoValue} ${classes.infoPadding}`}>
            {data.status}
          </div>
        </Grid>
        <Grid item xs={3} className={classes.rightPanelInfoSection}>
          <div className={classes.infoTitle}>Close Time:</div>
          <div className={`${classes.infoValue} ${classes.infoPadding}`}>
            {data.pickupCloseTime}
          </div>
        </Grid>
        <Grid item xs={3} className={classes.rightPanelInfoSection}>
          <div className={classes.infoTitle}>Ready Time:</div>
          <div className={`${classes.infoValue} ${classes.infoPadding}`}>
            {data.pickupReadyTime}
          </div>
        </Grid>
        <Grid item xs={3} className={classes.rightPanelInfoSection}>
          <div className={classes.infoTitle}>Date:</div>
          <div className={`${classes.infoValue} ${classes.infoPadding}`}>
            {formatMonthDateYearWithoutUTC({value:data.pickupDate})}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles)(index);
